import { toRefs, computed } from 'vue';

//

//  https://vuetifyjs.com/en/components/lists/#two-lines-and-subheader
var script = {
  name: 'List',
  props: {
    component: {
      type: String,
      default: 'div'
    },
    disabled: Boolean,
    dense: Boolean
  },
  setup(props) {
    const {
      disabled,
      dense
    } = toRefs(props);
    const classes = computed(() => {
      return {
        'v-list--disabled': disabled.value,
        'v-list--dense': dense.value
      };
    });
    return {
      classes
    };
  }
};
export { script as default };